module.exports = __webpack_public_path__ + "static/img/TORONTO_MAPLE.12b899a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/TORONTO_MAPLE.jpg
// module id = bI96
// module chunks = 0